import React from "react";
import { Row, Col, Form, Card } from "react-bootstrap";
import AccionistasTable from "../AccionistasTable";
import ReferenciasComercialesTable from "../ReferenciasComerciales";

const ProveedorInfoSection = ({
  formData,
  errors,
  handleChange,
  handleBlur,
  handleFocus,
  isReadOnly,
  isJuridica,
  showCustomFormaPago,
  idFormulario,
  setAccionistasTotal,
  setReferenciasTotal
}) => {
  const providerInfo = formData.providerInfo || {};

  return (
    <div className="form-section">
      <h5 className="bg-light p-2 mb-3 border-bottom">
        1.- INFORMACIÓN DEL PROVEEDOR
      </h5>

      <Row className="g-2 g-sm-3">

        <Col xs={12} md={6}>
          <Form.Group>
            <Form.Label className="required-field small fw-semibold">NÚMERO DE RUC</Form.Label>
            <Form.Control
              type="text"
              inputMode="numeric"
              maxLength="13"
              size="sm"
              isInvalid={!!errors.ruc}
              value={providerInfo.ruc || ""}
              onChange={(e) => {
                const value = e.target.value.replace(/\D/g, '');
                handleChange("ruc")({ target: { value } });
              }}
              onBlur={handleBlur("ruc")}
              onFocus={handleFocus("ruc")}
              disabled={isReadOnly}
            />
            <Form.Control.Feedback type="invalid" className="small">{errors.ruc}</Form.Control.Feedback>
          </Form.Group>
        </Col>

        {/* Razón Social */}
        <Col xs={12} md={6}>
          <Form.Group>
            <Form.Label className="required-field small fw-semibold">RAZÓN SOCIAL</Form.Label>
            <Form.Control
              type="text"
              maxLength="200"
              size="sm"
              isInvalid={!!errors.razon_social}
              value={providerInfo.razon_social || ""}
              onChange={handleChange("razon_social")}
              onBlur={handleBlur("razon_social")}
              onFocus={handleFocus("razon_social")}
              disabled={isReadOnly}
            />
            <Form.Control.Feedback type="invalid" className="small">{errors.razon_social}</Form.Control.Feedback>
          </Form.Group>
        </Col>

        {/* Razón Comercial */}
        <Col xs={12} md={6}>
          <Form.Group>
            <Form.Label className="small fw-semibold">RAZÓN COMERCIAL</Form.Label>
            <Form.Control
              type="text"
              maxLength="200"
              size="sm"
              isInvalid={!!errors.razon_comercial}
              value={providerInfo.razon_comercial || ""}
              onChange={handleChange("razon_comercial")}
              onBlur={handleBlur("razon_comercial")}
              onFocus={handleFocus("razon_comercial")}
              disabled={isReadOnly}
            />
            <Form.Control.Feedback type="invalid" className="small">{errors.razon_comercial}</Form.Control.Feedback>
          </Form.Group>
        </Col>

        {/* Cargo */}
        <Col xs={12} md={6}>
          <Form.Group>
            <Form.Label className="required-field small fw-semibold">CARGO</Form.Label>
            <Form.Control
              type="text"
              maxLength="100"
              size="sm"
              isInvalid={!!errors.cargo}
              value={providerInfo.cargo || ""}
              onChange={handleChange("cargo")}
              onBlur={handleBlur("cargo")}
              onFocus={handleFocus("cargo")}
              disabled={isReadOnly}
            />
            <Form.Control.Feedback type="invalid" className="small">{errors.cargo}</Form.Control.Feedback>
          </Form.Group>
        </Col>

        {/* Servicios */}
        <Col xs={12}>
          <Form.Group>
            <Form.Label className="required-field small fw-semibold">Servicios / Suministros que presta</Form.Label>
            <Form.Control
              as="textarea"
              rows={3}
              isInvalid={!!errors.servicios_prestados}
              value={providerInfo.servicios_prestados || ""}
              onChange={handleChange("servicios_prestados")}
              onBlur={handleBlur("servicios_prestados")}
              onFocus={handleFocus("servicios_prestados")}
              disabled={isReadOnly}
            />
            <Form.Control.Feedback type="invalid" className="small">{errors.servicios_prestados}</Form.Control.Feedback>
          </Form.Group>
        </Col>

        {/* Provincia */}
        <Col xs={12} md={6}>
          <Form.Group>
            <Form.Label className="required-field small fw-semibold">Provincia</Form.Label>
            <Form.Control
              type="text"
              maxLength="100"
              size="sm"
              isInvalid={!!errors.provincia}
              value={providerInfo.provincia || ""}
              onChange={handleChange("provincia")}
              onBlur={handleBlur("provincia")}
              onFocus={handleFocus("provincia")}
              disabled={isReadOnly}
            />
            <Form.Control.Feedback type="invalid" className="small">{errors.provincia}</Form.Control.Feedback>
          </Form.Group>
        </Col>

        {/* Cantón */}
        <Col xs={12} md={6}>
          <Form.Group>
            <Form.Label className="required-field small fw-semibold">Cantón</Form.Label>
            <Form.Control
              type="text"
              maxLength="100"
              size="sm"
              isInvalid={!!errors.canton}
              value={providerInfo.canton || ""}
              onChange={handleChange("canton")}
              onBlur={handleBlur("canton")}
              onFocus={handleFocus("canton")}
              disabled={isReadOnly}
            />
            <Form.Control.Feedback type="invalid" className="small">{errors.canton}</Form.Control.Feedback>
          </Form.Group>
        </Col>

        {/* Contribuyente Especial */}
        <Col xs={12} md={6}>
          <Form.Group>
            <Form.Label className="required-field small fw-semibold d-block">CONTRIBUYENTE ESPECIAL:</Form.Label>
            <div className="d-flex flex-row gap-3 mt-1">
              <Form.Check
                type="radio"
                id="contribuyenteSi"
                name="contribuyente_especial"
                label="SI"
                checked={providerInfo.contribuyente_especial === true}
                onChange={() => handleChange("contribuyente_especial")({ target: { value: true } })}
                disabled={isReadOnly}
              />
              <Form.Check
                type="radio"
                id="contribuyenteNo"
                name="contribuyente_especial"
                label="NO"
                checked={providerInfo.contribuyente_especial === false}
                onChange={() => handleChange("contribuyente_especial")({ target: { value: false } })}
                disabled={isReadOnly}
              />
            </div>
            {errors.contribuyente_especial && (
              <div className="text-danger small mt-1">{errors.contribuyente_especial}</div>
            )}
          </Form.Group>
        </Col>

        {/* Régimen RIMPE */}
        <Col xs={12} md={6}>
          <Form.Group>
            <Form.Label className="required-field small fw-semibold d-block">RÉGIMEN RIMPE:</Form.Label>
            <div className="d-flex flex-column flex-sm-row gap-2 flex-wrap mt-1">
              <Form.Check
                type="radio"
                id="negocioPopular"
                name="regimen_rimpe"
                label="NEGOCIO POPULAR"
                checked={providerInfo.regimen_rimpe === "NEGOCIO POPULAR"}
                onChange={() => handleChange("regimen_rimpe")({ target: { value: "NEGOCIO POPULAR" } })}
                disabled={isReadOnly}
              />
              <Form.Check
                type="radio"
                id="emprendedor"
                name="regimen_rimpe"
                label="EMPRENDEDOR"
                checked={providerInfo.regimen_rimpe === "EMPRENDEDOR"}
                onChange={() => handleChange("regimen_rimpe")({ target: { value: "EMPRENDEDOR" } })}
                disabled={isReadOnly}
              />
              <Form.Check
                type="radio"
                id="rimpeGeneral"
                name="regimen_rimpe"
                label="GENERAL"
                checked={providerInfo.regimen_rimpe === "GENERAL"}
                onChange={() => handleChange("regimen_rimpe")({ target: { value: "GENERAL" } })}
                disabled={isReadOnly}
              />
            </div>
            {errors.regimen_rimpe && (
              <div className="text-danger small mt-1">{errors.regimen_rimpe}</div>
            )}
          </Form.Group>
        </Col>

        {/* Dirección */}
        <Col xs={12}>
          <Form.Group>
            <Form.Label className="required-field small fw-semibold">DIRECCIÓN DE ESTABLECIMIENTO:</Form.Label>
            <Form.Control
              type="text"
              maxLength="500"
              size="sm"
              isInvalid={!!errors.direccion_establecimiento}
              value={providerInfo.direccion_establecimiento || ""}
              onChange={handleChange("direccion_establecimiento")}
              onBlur={handleBlur("direccion_establecimiento")}
              onFocus={handleFocus("direccion_establecimiento")}
              disabled={isReadOnly}
            />
            <Form.Control.Feedback type="invalid" className="small">{errors.direccion_establecimiento}</Form.Control.Feedback>
          </Form.Group>
        </Col>

        {/* Teléfonos */}
        <Col xs={12} sm={6} md={4}>
          <Form.Group>
            <Form.Label className="required-field small fw-semibold">TELÉFONO 1:</Form.Label>
            <Form.Control
              type="tel"
              maxLength="15"
              size="sm"
              isInvalid={!!errors.telefono1}
              value={providerInfo.telefono1 || ""}
              onChange={handleChange("telefono1")}
              onBlur={handleBlur("telefono1")}
              onFocus={handleFocus("telefono1")}
              disabled={isReadOnly}
            />
            <Form.Control.Feedback type="invalid" className="small">{errors.telefono1}</Form.Control.Feedback>
          </Form.Group>
        </Col>

        <Col xs={12} sm={6} md={4}>
          <Form.Group>
            <Form.Label className="small fw-semibold">TELÉFONO 2:</Form.Label>
            <Form.Control
              type="tel"
              maxLength="15"
              size="sm"
              isInvalid={!!errors.telefono2}
              value={providerInfo.telefono2 || ""}
              onChange={handleChange("telefono2")}
              onBlur={handleBlur("telefono2")}
              onFocus={handleFocus("telefono2")}
              disabled={isReadOnly}
            />
            <Form.Control.Feedback type="invalid" className="small">{errors.telefono2}</Form.Control.Feedback>
          </Form.Group>
        </Col>

        <Col xs={12} sm={6} md={4}>
          <Form.Group>
            <Form.Label className="small fw-semibold">TELÉFONO 3:</Form.Label>
            <Form.Control
              type="tel"
              maxLength="15"
              size="sm"
              isInvalid={!!errors.telefono3}
              value={providerInfo.telefono3 || ""}
              onChange={handleChange("telefono3")}
              onBlur={handleBlur("telefono3")}
              onFocus={handleFocus("telefono3")}
              disabled={isReadOnly}
            />
            <Form.Control.Feedback type="invalid" className="small">{errors.telefono3}</Form.Control.Feedback>
          </Form.Group>
        </Col>

        {/* Persona de Contacto */}
        <Col xs={12} md={6}>
          <Form.Group>
            <Form.Label className="required-field small fw-semibold">PERSONA DE CONTACTO:</Form.Label>
            <Form.Control
              type="text"
              maxLength="100"
              size="sm"
              isInvalid={!!errors.persona_contacto}
              value={providerInfo.persona_contacto || ""}
              onChange={handleChange("persona_contacto")}
              onBlur={handleBlur("persona_contacto")}
              onFocus={handleFocus("persona_contacto")}
              disabled={isReadOnly}
            />
            <Form.Control.Feedback type="invalid" className="small">{errors.persona_contacto}</Form.Control.Feedback>
          </Form.Group>
        </Col>

        {/* Email Contacto */}
        <Col xs={12} md={6}>
          <Form.Group>
            <Form.Label className="required-field small fw-semibold">EMAIL DE CONTACTO:</Form.Label>
            <Form.Control
              type="email"
              maxLength="100"
              size="sm"
              isInvalid={!!errors.email_contacto}
              value={providerInfo.email_contacto || ""}
              onChange={handleChange("email_contacto")}
              onBlur={handleBlur("email_contacto")}
              onFocus={handleFocus("email_contacto")}
              disabled={isReadOnly}
            />
            <Form.Control.Feedback type="invalid" className="small">{errors.email_contacto}</Form.Control.Feedback>
          </Form.Group>
        </Col>

        {/* Forma de Pago */}
        <Col xs={12} md={6}>
          <Form.Group>
            <Form.Label className="required-field small fw-semibold">FORMA DE PAGO:</Form.Label>
            <Form.Select
              size="sm"
              isInvalid={!!errors.forma_pago}
              value={providerInfo.forma_pago || ""}
              onChange={handleChange("forma_pago")}
              onBlur={handleBlur("forma_pago")}
              onFocus={handleFocus("forma_pago")}
              disabled={isReadOnly}
            >
              <option value="">Seleccionar</option>
              <option value="Contado">Contado</option>
              <option value="Crédito">Crédito</option>
            </Form.Select>
            <Form.Control.Feedback type="invalid" className="small">{errors.forma_pago}</Form.Control.Feedback>
          </Form.Group>
        </Col>

        {showCustomFormaPago && (
          <Col xs={12} md={6}>
            <Form.Group>
              <Form.Label className="required-field small fw-semibold">ESPECIFIQUE FORMA DE PAGO:</Form.Label>
              <Form.Control
                type="text"
                maxLength="50"
                size="sm"
                isInvalid={!!errors.forma_pago_otro}
                value={providerInfo.forma_pago_otro || ""}
                onChange={handleChange("forma_pago_otro")}
                onBlur={handleBlur("forma_pago_otro")}
                onFocus={handleFocus("forma_pago_otro")}
                placeholder="Escriba la forma de pago"
                disabled={isReadOnly}
              />
              <Form.Control.Feedback type="invalid" className="small">{errors.forma_pago_otro}</Form.Control.Feedback>
            </Form.Group>
          </Col>
        )}

        {/* Sección Jurídica */}
        {isJuridica && (
          <>
            <Col xs={12} md={6}>
              <Form.Group>
                <Form.Label className="required-field small fw-semibold">Representante Legal</Form.Label>
                <Form.Control
                  type="text"
                  maxLength="100"
                  size="sm"
                  isInvalid={!!errors.representante_legal}
                  value={providerInfo.representante_legal || ""}
                  onChange={handleChange("representante_legal")}
                  onBlur={handleBlur("representante_legal")}
                  onFocus={handleFocus("representante_legal")}
                  disabled={isReadOnly}
                />
                <Form.Control.Feedback type="invalid" className="small">{errors.representante_legal}</Form.Control.Feedback>
              </Form.Group>
            </Col>

            <Col xs={12} md={6}>
              <Form.Group>
                <Form.Label className="required-field small fw-semibold">Cédula Representante</Form.Label>
                <Form.Control
                  type="text"
                  inputMode="numeric"
                  maxLength="10"
                  size="sm"
                  isInvalid={!!errors.cedula_representante}
                  value={providerInfo.cedula_representante || ""}
                  onChange={(e) => {
                    const value = e.target.value.replace(/\D/g, '');
                    handleChange("cedula_representante")({ target: { value } });
                  }}
                  onBlur={handleBlur("cedula_representante")}
                  onFocus={handleFocus("cedula_representante")}
                  disabled={isReadOnly}
                />
                <Form.Control.Feedback type="invalid" className="small">{errors.cedula_representante}</Form.Control.Feedback>
              </Form.Group>
            </Col>

            <Col xs={12}>
              <hr className="my-3" />
              <AccionistasTable
                idFormulario={idFormulario}
                isReadOnly={isReadOnly}
                onTotalChange={setAccionistasTotal}
              />
            </Col>

            <Col xs={12}>
              <hr className="my-3" />
              <ReferenciasComercialesTable
                idFormulario={idFormulario}
                isReadOnly={isReadOnly}
                onTotalChange={setReferenciasTotal}
              />
            </Col>
          </>
        )}

      </Row>
    </div>
  );
};

export default ProveedorInfoSection;